import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55fc0cb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "periodontal-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_periodontal_pdf = _resolveComponent("periodontal-pdf")!
  const _component_w_report_header = _resolveComponent("w-report-header")!
  const _component_periodontal_preview = _resolveComponent("periodontal-preview")!
  const _component_periodontal_map = _resolveComponent("periodontal-map")!
  const _component_w_consolidated_report = _resolveComponent("w-consolidated-report")!
  const _component_w_report_comments = _resolveComponent("w-report-comments")!
  const _component_w_report_submit = _resolveComponent("w-report-submit")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["periodontal-page__wrapper", { 'periodontal-page__wrapper--preview': _ctx.isPreviewMode }])
    }, [
      _createVNode(_component_periodontal_pdf, {
        class: "periodontal-page__pdf",
        "report-info": _ctx.reportInfo,
        data: _ctx.periodontalData,
        plaque: _ctx.consolidatedPlaque,
        bleeding: _ctx.consolidatedBleeding,
        pockets: _ctx.consolidatedPockets,
        "pockets-table": _ctx.consolidatedPocketsTable,
        comments: _ctx.comments,
        "consolidated-data": _ctx.consolidatedData
      }, null, 8, ["report-info", "data", "plaque", "bleeding", "pockets", "pockets-table", "comments", "consolidated-data"]),
      (_ctx.reportInfo.id)
        ? (_openBlock(), _createBlock(_component_w_report_header, {
            key: 0,
            "report-info": _ctx.reportInfo,
            "report-type": _ctx.REPORT_VIEW.periodontal
          }, null, 8, ["report-info", "report-type"]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_periodontal_preview, {
        "report-info": _ctx.reportInfo,
        data: _ctx.periodontalData,
        plaque: _ctx.consolidatedPlaque,
        bleeding: _ctx.consolidatedBleeding,
        pockets: _ctx.consolidatedPockets,
        "pockets-table": _ctx.consolidatedPocketsTable,
        comments: _ctx.comments,
        "consolidated-data": _ctx.consolidatedData
      }, null, 8, ["report-info", "data", "plaque", "bleeding", "pockets", "pockets-table", "comments", "consolidated-data"]), [
        [_vShow, _ctx.isPreviewMode]
      ]),
      (!_ctx.isPreviewMode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_periodontal_map, {
              class: "periodontal-page__card",
              data: _ctx.periodontalData
            }, null, 8, ["data"]),
            (_ctx.reportInfo.id)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_w_consolidated_report, {
                    class: "periodontal-page__card",
                    plaque: _ctx.consolidatedPlaque,
                    bleeding: _ctx.consolidatedBleeding,
                    pockets: _ctx.consolidatedPockets,
                    "pockets-table": _ctx.consolidatedPocketsTable,
                    "consolidated-data": _ctx.consolidatedData
                  }, null, 8, ["plaque", "bleeding", "pockets", "pockets-table", "consolidated-data"]),
                  (_openBlock(), _createBlock(_component_w_report_comments, {
                    class: "periodontal-page__card",
                    key: _ctx.comments,
                    comments: _ctx.comments,
                    templates: _ctx.commentTemplates,
                    "report-type": _ctx.REPORT_VIEW.periodontal,
                    onUpdate: _ctx.getFullReport
                  }, null, 8, ["comments", "templates", "report-type", "onUpdate"])),
                  _createVNode(_component_w_report_submit, {
                    "report-type": _ctx.REPORT_VIEW.periodontal,
                    email: _ctx.email
                  }, null, 8, ["report-type", "email"])
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ], 2)
  ])), [
    [
      _directive_loading,
      _ctx.loading,
      void 0,
      { body: true }
    ]
  ])
}